export enum Connectors {
  DATA_LOSS_PREVENTION = 'Data Loss Prevention',
  NATURAL_LANGUAGE = 'naturallanguage',
  TEXT_TO_SPEECH = 'texttospeech',
  TRANSLATE = 'Translate',
  RASA = 'Rasa'
}
